if (!customElements.get('connected-color-swatches')) {
  class ConnectedColorSwatches extends HTMLElement {
    #defaultLabel = '';
    #labelElement = null;

    connectedCallback() {
      this.#defaultLabel = this.dataset.defaultLabel || '';
      this.#labelElement = this.querySelector('[data-connected-color-label]');

      if (!this.#labelElement) {
        return;
      }

      this.addEventListener('pointerover', this.#onPointerOver);
      this.addEventListener('pointerleave', this.#onPointerLeave);
      this.addEventListener('focusin', this.#onFocusIn);
      this.addEventListener('focusout', this.#onFocusOut);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerover', this.#onPointerOver);
      this.removeEventListener('pointerleave', this.#onPointerLeave);
      this.removeEventListener('focusin', this.#onFocusIn);
      this.removeEventListener('focusout', this.#onFocusOut);
    }

    #onPointerOver = (event) => {
      this.#updateLabelFromSwatch(event.target);
    };

    #onPointerLeave = (event) => {
      if (event.relatedTarget && this.contains(event.relatedTarget)) {
        return;
      }

      this.#resetLabel();
    };

    #onFocusIn = (event) => {
      this.#updateLabelFromSwatch(event.target);
    };

    #onFocusOut = (event) => {
      if (event.relatedTarget && this.contains(event.relatedTarget)) {
        return;
      }

      this.#resetLabel();
    };

    #updateLabelFromSwatch(target) {
      const swatch = target.closest('.variant-picker__option-values a');

      if (!swatch) {
        return;
      }

      const colorName = swatch.querySelector('.sr-only')?.textContent.trim();

      if (colorName) {
        this.#labelElement.textContent = colorName;
      }
    }

    #resetLabel() {
      this.#labelElement.textContent = this.#defaultLabel;
    }
  }

  customElements.define('connected-color-swatches', ConnectedColorSwatches);
}
